import React, {Component} from 'react';
import {connect} from 'react-redux';
import HTML5Backend from 'react-dnd-html5-backend';
import {DragDropContext} from 'react-dnd';
import {
    Grid,
    Tab,
    Tabs,
    withStyles
} from 'material-ui';
import {builderStyles} from './style/builder';
import {setTemplatesTab} from '../../layout/actions';
import {fetchTemplate, fetchElements} from '../thunks';
import Template from './sections/tab_dnd/Sections';
import ElementsContainer from './ElementsContainer';
import EditsHistory from './EditsHistory';

class TemplateBuilder extends Component {

    handleChange = (event, value) => {
        this.props.setTemplatesTab(value, this.props.match.params.id);
    };

    componentDidMount() {
        this.props.fetchTemplate(Number(this.props.match.params.id));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.pageTypeId !== this.props.pageTypeId) {
            this.props.fetchElements(this.props.pageTypeId);
        }
    }

    render() {
        const {classes, template, elements, loading, activeTabData} = this.props;

        if (!template.template) {
            return null;
        }

        let templateId = Number(this.props.match.params.id);
        let activeTab = 0;

        if (activeTabData[this.props.match.params.id]) {
            activeTab = activeTabData[this.props.match.params.id];
        }

        return (
            <div>
                <Tabs
                    value={activeTab}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Edit Template" />
                    <Tab label="Edits History" />
                </Tabs>
                <Grid container spacing={24}>
                    {activeTab === 0 &&
                        [
                            <Template
                                key={0}
                                template={template}
                                templateId={templateId}
                            />,
                            <ElementsContainer
                                key={1}
                                classes={classes}
                                elements={elements}
                                loading={loading}
                            />
                        ]
                    }
                    {activeTab === 1 &&
                        <EditsHistory 
                            template={template}
                            classes={classes}
                            loading={loading}
                        />
                    }
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    template: state.template.template,
    elements: state.template.elements,
    activeTabData: state.layout.activeTemplatesTab,
    loading: state.layout.ajaxCallsInProgress > 0,
    pageTypeId: state.template.pageTypeId
});

export default connect(mapStateToProps, {
    fetchTemplate,
    fetchElements,
    setTemplatesTab
}
)(withStyles(builderStyles)(DragDropContext(HTML5Backend)(TemplateBuilder)));




// WEBPACK FOOTER //
// ./src/containers/templates/builder/TemplateBuilder.jsx